import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
    BiCartAlt,
    BiLaptop,
    BiUserCircle
} from 'react-icons/bi';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import { useAppSelector } from 'hooks/useStore';
import './index.css';

function Hamburger({ transparent }: { transparent: boolean; }) {
    const [open, setOpen] = useState(false);

    const user = useAppSelector(state => state.user.user);
    const ref = useOutsideClickHandler(() => setOpen(false));

    return (
        <button className={
            open ? 'hamburger--open' : transparent ? 'hamburger--transparent' : 'hamburger'} 
            onClick={() => setOpen(!open)}
            ref={ref}
        >
            <div className='hamburger__top'></div>
            <div className='hamburger__mid'></div>
            <div className='hamburger__bot'></div>
            <div className={open ? 'hamburger__menu--open' : 'hamburger__menu'} ref={ref}>
                {/* <NavLink 
                    to='/courses'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Courses
                </NavLink> */}
                {/* <NavLink
                    to='/tests'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Tests
                </NavLink> */}
                <NavLink
                    to='/tests/digital-act'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Digital ACT
                </NavLink>
                <NavLink
                    to='/tests/digital-sat'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Digital SAT
                </NavLink>
                <NavLink
                    to='/tests/digital-psat'
                    className={({ isActive }) => (
                        isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                    )}
                >
                    Digital PSAT
                </NavLink>
                {user
                    ?   <>
                            {/* <NavLink
                                to='/cart'
                                className={({ isActive }) => (
                                    isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                                )}
                            >
                                <BiCartAlt className='hamburger__menuItemIcon' />
                                My Cart
                                {(courses.length > 0 || tests.length > 0 || bundles.length > 0) && 
                                    <p className='hamburger__cartBadge'>{courses.length + tests.length + 
                                        bundles.reduce((count, bundle) => (
                                            count + (bundle.numRequired ? 0 : (bundle.courses.length + bundle.tests.length))
                                        ), 0)
                                    }</p>
                                }
                            </NavLink> */}
                            <NavLink
                                to='/account'
                                className={({ isActive }) => (
                                    isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                                )}
                            >
                                <BiUserCircle className='hamburger__menuItemIcon' />
                                Account
                            </NavLink>
                        </>
                    :   <NavLink
                            to='/sign-in'
                            className={({ isActive }) => (
                                isActive ? 'hamburger__menuItem--active' : 'hamburger__menuItem'
                            )}
                        >
                            Sign In
                        </NavLink>
                }
            </div>
        </button>
    );
}

export default Hamburger;